import {Component, Inject, OnInit} from '@angular/core';

import {FieldComponent} from '../../field/field.component';
import {TranslateService} from '@ngx-translate/core';
import {HelperService} from '../../helper.service';
import {AuthService} from '../../auth.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { ManagementService } from 'src/app/services/management.service';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';

@Component({
    selector: 'app-confirm-profile-delete',
    templateUrl: './confirm-profile-delete.component.html',
    styleUrls: ['./confirm-profile-delete.component.css'],
    standalone: false
})
export class ConfirmProfileDeleteComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<FieldComponent>,
              public dialog: MatDialog,
              public translate: TranslateService,
              public managementService: ManagementService,
              public helper: HelperService,
              private nav: NavBarComponent,
              public auth: AuthService) { }

  ngOnInit(): void {
  }

  confirmDelete() {
    this.nav.toggleLoading(true);
    this.managementService.deleteUserById(this.helper.getUserId()).subscribe({
      next: (result) => {
        this.nav.toggleLoading(false);
        this.dialogRef.close({option: 'yes'});
        this.auth.logout(true);
      },
      error: (error) => {
        console.error(error);
        this.nav.toggleLoading(false);
      }
    });
  }

  cancel(): void {
    this.dialogRef.close({option: 'cancel'});
  }

}
